import React, { useEffect, useState } from "react";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on load

    fetch("/assets/txt/privacyPolicy.txt")
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch((err) => {
        console.error("Failed to load Privacy Policy:", err);
        setContent("Unable to load Privacy Policy at the moment.");
      });
  }, []);

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh", padding: "2rem 1rem" }}>
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#fff",
          padding: "3rem",
          borderRadius: "16px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
          borderTop: "6px solid #ff9559",
        }}
      >
        <h1 style={{ color: "#001F3F", fontSize: "2.5rem", marginBottom: "1rem" }}>
          Privacy Policy
        </h1>
        <p style={{ color: "#666", fontSize: "1.1rem", marginBottom: "2rem" }}>
          Last updated: April 14, 2025
        </p>
        <div
          style={{
            color: "#333",
            whiteSpace: "pre-wrap",
            lineHeight: "1.7",
            fontSize: "1rem",
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
